import "./index.css";
import "./global.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllRouter from "./AllRouter/AllRouter";
import SEOHead from "@shared/SEO/SEOHead";
import CookieConsent from "@shared/CookieConsent/CookieConsent";
import ThirdPartyScripts from "@shared/SEO/ThirdPartyScripts";
import { hydrateAuthenticatedUser } from "@state/actions/authActions";
import SentryTracker from "@lib/sentry/SentryTracker";
function App() {
  const dispatch = useDispatch();
  const hasBootstrappedUser = useRef(false);

  useEffect(() => {
    if (hasBootstrappedUser.current) {
      return;
    }

    hasBootstrappedUser.current = true;
    void dispatch(hydrateAuthenticatedUser());
  }, [dispatch]);

  return (
    <div className="App">
      <SEOHead />
      <ThirdPartyScripts />
      <SentryTracker />
      <AllRouter />
      <CookieConsent />
      <ToastContainer newestOnTop={true} />
    </div>
  );
}

export default App;
